import { render, staticRenderFns } from "./electronInfo.vue?vue&type=template&id=47e25850&scoped=true&"
import script from "./electronInfo.vue?vue&type=script&lang=js&"
export * from "./electronInfo.vue?vue&type=script&lang=js&"
import style0 from "./electronInfo.vue?vue&type=style&index=0&id=47e25850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e25850",
  null
  
)

export default component.exports